import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroProjects() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="6686" id="hero" className="relative w-full bg-background py-24 md:py-32 lg:py-40 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603628/img/image_b79xa48p.png)] bg-cover bg-center opacity-5 dark:opacity-10" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/0 via-background/50 to-background" />
      </div>

      <div ref={containerRef} className={`container relative z-10 mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-foreground mb-6 max-w-4xl">Besichtigung buchen oder <span className="text-primary" data-ast-id="f:/src/pages/BookViewing/sections/HeroProjects.tsx|sig:p8yc2l" data-ast-start="1313" data-ast-end="1365">Raum anfragen.</span></h1>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 leading-relaxed font-sans">
          Schreib uns oder ruf an – wir antworten schnell, versprochen. Wir freuen uns darauf, dich in unserem Coworking Space willkommen zu heißen.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Link to="/Besichtigung Buchen" className="w-full sm:w-auto">
            
          </Link>
        </div>
      </div>
    </section>;
}